import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { displayDateAndTimeInTimezone } from '../../../../../common/util/formatTimespan';
import { Text } from '@instructure/ui-text';
import { Flex } from '@instructure/quiz-common';
export var AnalysisUpdateDate = /*#__PURE__*/function (_Component) {
  function AnalysisUpdateDate() {
    _classCallCheck(this, AnalysisUpdateDate);
    return _callSuper(this, AnalysisUpdateDate, arguments);
  }
  _inherits(AnalysisUpdateDate, _Component);
  return _createClass(AnalysisUpdateDate, [{
    key: "render",
    value: function render() {
      var _this$context = this.context,
        timezone = _this$context.timezone,
        locale = _this$context.locale;
      var _this$props = this.props,
        date = _this$props.date,
        multiline = _this$props.multiline;
      return /*#__PURE__*/React.createElement(Text, {
        size: "x-small"
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: multiline ? 'column' : 'row',
        alignItems: "start"
      }, /*#__PURE__*/React.createElement("span", null, t('Data Last Updated:'), "\xA0"), /*#__PURE__*/React.createElement("span", null, displayDateAndTimeInTimezone(date, timezone, locale))));
    }
  }]);
}(Component);
_defineProperty(AnalysisUpdateDate, "propTypes", {
  date: PropTypes.string.isRequired,
  multiline: PropTypes.bool
});
_defineProperty(AnalysisUpdateDate, "contextTypes", {
  timezone: PropTypes.string,
  locale: PropTypes.string
});
_defineProperty(AnalysisUpdateDate, "defaultProps", {
  multiline: false
});